<template>
  <section class="section section--alt">
    <div class="container">
      <h2 class="section-title fade-in-up">いつものLINEで、3ステップ注文。</h2>
      <div class="row mt-5">
        <!-- ステップ1 -->
        <div class="col-md-4 text-center step-col fade-in-up delay-1">
          <div class="step-badge">1</div>
          <h3 class="step-title">Scan &amp; Add</h3>
          <p class="step-desc">スマホでQRコードをスキャン＆友達登録</p>
        </div>
        <!-- ステップ2 -->
        <div class="col-md-4 text-center step-col fade-in-up delay-2">
          <div class="step-badge">2</div>
          <h3 class="step-title">Select</h3>
          <p class="step-desc">お好きなお弁当を選択</p>
        </div>
        <!-- ステップ3 -->
        <div class="col-md-4 text-center step-col fade-in-up delay-3">
          <div class="step-badge">3</div>
          <h3 class="step-title">Reserve</h3>
          <p class="step-desc">予約・お支払いで、あとは待つだけ</p>
        </div>
      </div>
      <!-- ステップ間の矢印（デスクトップのみ） -->
      <div class="step-arrows d-none d-md-flex">
        <div class="step-arrow"></div>
        <div class="step-arrow"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionHowto',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';
@import '@/assets/scss/mixins';

.step-col {
  margin-bottom: 2rem;
  position: relative;
}

.step-badge {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, $color-primary 0%, $color-primary-dark 100%);
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  box-shadow: 0 4px 12px rgba($color-primary, 0.3);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.step-title {
  font-size: $font-size-section-subtitle;
  font-weight: 700;
  color: $color-text;
  margin-bottom: 0.75rem;
}

.step-desc {
  font-size: $font-size-body;
  color: $color-text-light;
  line-height: 1.8;
}

// ステップ間の矢印（装飾用）
.step-arrows {
  justify-content: center;
  gap: 33%;
  margin-top: -2rem;
  position: relative;
  pointer-events: none;
}

.step-arrow {
  width: 24px;
  height: 24px;
  border-right: 3px solid $color-primary;
  border-bottom: 3px solid $color-primary;
  transform: rotate(-45deg);
  opacity: 0.4;
}
</style>
